import AgendaListRow                from '@/pages/Agenda/components/AgendaListRow';
import { Box }                      from '@chakra-ui/react';
import CalendarIcon                 from '@/assets/icons/CalendarIcon';
import { Link }                     from 'react-router-dom';
import List                         from '@/components/list/List';
import usePagedCollection           from '@widesk-core/hooks/usePagedCollection';
import { useTranslation }           from 'react-i18next';
import WebsiteEntertainmentModel    from '@/models/services/website/WebsiteEntertainmentModel';
import UserEventModel               from '@/models/services/website/UserEventModel';
import links                        from '@/tools/links';

interface IAgendaListBoxProps {
	websiteEntertainment: WebsiteEntertainmentModel;
}

const AgendaListBox = (props: IAgendaListBoxProps) => {
	const { websiteEntertainment } = props;

	const { t, i18n } = useTranslation();

	const agendaCollection = usePagedCollection(UserEventModel);

	const baseUrl = websiteEntertainment.website.url;
	const year = websiteEntertainment.slugPrefix;
	const lang = i18n.language;
	const websiteLink = `${baseUrl}/${links.events(lang, year)}`;

	return (
		<List
			afterFetch={async() => {
				await agendaCollection.whenIsLoaded(m => m.event.place);

				agendaCollection.models.sort((a, b) => {
					const aEvent = a.event;
					const bEvent = b.event;

					// Événements sans date → tout à la fin
					if (!aEvent.dayIsFinal && bEvent.dayIsFinal) return 1;
					if (aEvent.dayIsFinal && !bEvent.dayIsFinal) return -1;
					if (!aEvent.dayIsFinal && !bEvent.dayIsFinal) return 0;

					// Tri chronologique par date
					const dateDiff = aEvent.date.valueOf() - bEvent.date.valueOf();
					if (dateDiff !== 0) return dateDiff;

					// Même date : événements sans heure → après ceux avec heure
					if (!aEvent.hourIsFinal && bEvent.hourIsFinal) return 1;
					if (aEvent.hourIsFinal && !bEvent.hourIsFinal) return -1;

					// Même date + les deux ont une heure → tri par heure
					return aEvent.startDate.valueOf() - bEvent.startDate.valueOf();
				});
			}}
			collection={agendaCollection}
			renderRow={(model) => <AgendaListRow agenda={model} websiteEntertainment={websiteEntertainment} />}
			options={{
				clickable: true,
				emptyAlert: websiteLink ? {
					title: (
						<Box display="inline" width="100%">
							<span>{t('pages.agenda.list.empty.alert.part1')} </span>

							<Link to={websiteLink} target="_blank" style={{ fontWeight: 'bold', textDecoration: 'underline', width: 'fit-content' }}>
								{t('pages.agenda.list.empty.alert.link')}
							</Link>

							<span> {t('pages.agenda.list.empty.alert.part2')}</span>
						</Box>
					),
				} : undefined,
				emptyMessages: {
					title: t('pages.agenda.list.empty.title'),
					description: t('pages.agenda.list.empty.description'),
					icon: <CalendarIcon size="xl" />,
				},
				filters: {
					'event.websiteEntertainment': websiteEntertainment.id,
				},
				itemsMargin: '10px 0px 10px 0px',
				itemsPadding: '10px',
				padding: '0px 10px 0px 10px',
				withSeparators: true,
			}}
		/>
	)
}

export default AgendaListBox;